import { TEXTBOX } from "../../utils/constants";
import styles from "./YuJaRadioBox.module.css";


export const YuJaRadioBox = ({checked=false, disabled=false, label="", onClick=()=>{}, labelStyle={}, size=17, ...props}) => {
    const onClickEvent = (e) => {
        if (disabled) {
            return
        }
        e.currentTarget.value=props.value;
        e.currentTarget.name=props.name;
        e.currentTarget.checked = true;
        e.target.value = props.value;
        e.target.name = props.name;
        e.target.checked = true;
        onClick(e);
    }

    const getIconSize = (parentSize) => {
        let result = Math.floor(parentSize / 2);

        if (parentSize % 2 === 0 && result % 2 !== 0) {
            result++;
        } else if (parentSize % 2 !== 0 && result % 2 === 0) {
            result++;
        }

        return result;
    }

    return (
        <div className={`${styles.container} ${disabled ? styles.disabled : ""}`}  {...props} onClick={onClickEvent} role={TEXTBOX}>
            <div
                tabIndex={disabled ? -1 : 0}
                style={{width: size, height: size, borderRadius: size}}
                className={styles.box}
            >
                {checked &&
                    <span className={styles.circle} style={{width: getIconSize(size), height: getIconSize(size), borderRadius: getIconSize(size)}}/>
                }
            </div>
            {label &&
                <span className={styles.label} style={{...labelStyle}}>{label}</span>
            }
        </div>
    )
}